export default __webpack_public_path__ + "static/media/azaaLogo.805b8575.svg";